export default {
  viewStatsContent: {
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '0px 0px 10px 10px',
    textAlign: 'center',
    backgroundColor: 'tmBlue',
    marginTop: '0px',
    width: '130px',
    paddingLeft: '0px',
    alignSelf: 'center',
    fontSize: '18px',
    pb: '8px',
  },
  containerStyles: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    WebkitAlignItems: 'center',
  },
  arrowLogo: {
    width: '10px',
    height: 'auto',
    ml: '10px',
  },
  stats: {
    display: ['none', 'none', 'flex'],
    flexDirection: 'column',
    textAlign: 'center',
    alignItems: 'center',
  },
  statLine: {
    display: 'flex',
    marginTop: '10px',
  },
  statMobile: {
    display: 'flex',
    my: '10px',
  },
}
